export * from './login'
export * from './logout'
export * from './request_password'
export * from './reset_password'
export * from './validate_token'

// const try_force_logoff = ( response ) => {
//   if (response !== undefined && response.force_logoff === true ) {
//     return {
//       type: auth_types.LOGOUT.force
//     }
//   }
//   return {
//     type: "DUMMY"
//   }
// }
//
// export {
//   try_force_logoff
// }



// WEBPACK FOOTER //
// ./src/js/actions/auth/index.js